export default __webpack_public_path__ + "static/media/na.60d66731.svg";